export const DINNER_CATEGORIES = [
  {
    id: "manners",
    label: "Manners talk",
    questions: [
      "Grown-ups: how were manners taught to you when you were a kid?",
      "Grown-ups: what manner were you always reminded about growing up?",
      "Grown-ups: what was a family rule at your dinner table as a kid?",
      "What is your biggest manners pet peeve?",
      "What rude habit do you notice most in public?",
      "Who is the politest person you know, and what do they do?",
      "Who is the rudest person you've ever met? (No names!) What did they do?",
      "Which celebrity seems the nicest, and why?",
      "Which celebrity seems the rudest, and what would you tell them?",
      "What is one manner you think everyone should know?",
      "What is a manner that's different in other countries or families?",
      "What's the most polite thing a stranger ever did for you?",
      "Which manner is the hardest for you to remember?",
      "If you could make one new manners rule for the world, what would it be?",
      "Who at this table has the best manners this week?",
    ],
  },
  {
    id: "gratitude",
    label: "Gratitude",
    questions: [
      "What is one thing that made you smile today?",
      "Who helped you this week, and how can you thank them?",
      "What is something at this table you are thankful for?",
      "What is a small thing that made your day better?",
      "Who is someone you'd like to write a thank-you note to?",
      "What is your favorite thing about our family?",
      "What is something you have now that you once wished for?",
      "Who at this table did something kind today?",
    ],
  },
  {
    id: "kindness",
    label: "Kindness",
    questions: [
      "What is one kind thing you did for someone today?",
      "How could you help someone who feels left out?",
      "What is the kindest thing anyone ever said to you?",
      "How can we make someone's day better tomorrow?",
      "What would you do if you saw someone being teased?",
      "What does being a good friend look like?",
      "When is it hard to be kind, and what helps?",
    ],
  },
  {
    id: "fun",
    label: "Just for fun",
    questions: [
      "If you could have any superpower, what would it be and why?",
      "If our family had a theme song, what would it be?",
      "What animal would you be for a day?",
      "If you could invent a new holiday, what would we celebrate?",
      "What would you cook if you were the chef tonight?",
      "If you could visit anywhere in the world, where would you go?",
      "What's the silliest thing that happened this week?",
      "If you wrote a book, what would it be about?",
    ],
  },
  {
    id: "wouldyou",
    label: "Would you rather",
    questions: [
      "Would you rather be able to fly or be invisible?",
      "Would you rather live by the beach or in the mountains?",
      "Would you rather have a pet dragon or a pet unicorn?",
      "Would you rather eat only pizza or only tacos for a week?",
      "Would you rather talk to animals or speak every language?",
      "Would you rather explore space or the deep ocean?",
    ],
  },
  {
    id: "family",
    label: "Family stories",
    questions: [
      "What is your favorite family memory?",
      "Grown-ups: what were dinners like when you were a kid?",
      "What family tradition should we start?",
      "What is something new you learned about someone here?",
      "What makes our family special?",
      "Grown-ups: what is a mistake you made and learned from?",
    ],
  },
  {
    id: "grow",
    label: "Growing up",
    questions: [
      "What is something hard you did this week?",
      "What is something you want to get better at?",
      "What does respect mean to you?",
      "When did you feel proud of yourself recently?",
      "What is one good manner you practiced today?",
      "How do you calm down when you feel upset?",
    ],
  },
];

const CUSTOM_KEY = "pp_dinner_custom";
export const getCustomQuestions = () => JSON.parse(localStorage.getItem(CUSTOM_KEY) || "[]");
export const saveCustomQuestions = (qs) => localStorage.setItem(CUSTOM_KEY, JSON.stringify(qs));

export const allCategories = () => {
  const custom = getCustomQuestions();
  return custom.length ? [{ id: "custom", label: "Our family", questions: custom }, ...DINNER_CATEGORIES] : DINNER_CATEGORIES;
};

export const pickQuestion = (cats, used) => {
  const pool = allCategories().filter((c) => cats.includes(c.id))
    .flatMap((c) => c.questions.map((q) => ({ q, cat: c.label })))
    .filter((x) => !used.includes(x.q));
  return pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
};
